import api from '../api';

/**
 * Load candidate activity timeline (admin / recruiter).
 * Tries dedicated route first so /candidates/:id never treats "history" as an id.
 */
export async function fetchCandidateHistory(candidateId) {
  const id = String(candidateId || '').trim();
  if (!id) throw new Error('candidateId is required');

  const attempts = [
    () => api.get('/candidate-history', { params: { candidateId: id } }),
    () => api.get(`/candidates/${encodeURIComponent(id)}/history`),
    () => api.get('/candidates/history', { params: { candidateId: id } })
  ];

  let lastError;
  for (const attempt of attempts) {
    try {
      const res = await attempt();
      return res.data;
    } catch (err) {
      lastError = err;
      const status = err.response?.status;
      if (status && status !== 404) throw err;
    }
  }
  throw lastError;
}
